import { JSX } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { List as SerendieList } from "@serendie/ui";

export class List extends BaseComponent<IListProps, IListState>
{
    public render(): JSX.Element
    {
        return <SerendieList
            {...this.props}
        />
    }
}

export interface IListProps extends React.ComponentProps<typeof SerendieList> { }
export interface IListState { }
